/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useCallback } from 'react';

import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { MLModalService } from 'ml-portals-services-react';
import { MLDisclosureUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLDisclosureComponent, MLScriptComponent } from 'ml-components-common-react';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';

import '@xengage/gw-platform-translations';
import _ from 'lodash';
import appConfig from 'app-config';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { UserService } from 'gw-capability-gateway';
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import { platformMessages } from 'ml-components-platform-react';
import messages from './HODisclosureToQuote.messages';
import metadata from './HODisclosureToQuote.metadata.json5';

// ML: MLHODisclosureCtrl.js, ml-ho-disclosure.html

function HODisclosureToQuote(props) {
    const translator = useTranslator();
    const isGPA = appConfig.portalCode === 'GPA';
    const { authHeader } = useAuthentication();
    const {
        wizardData: submissionVM, goNext, currentStep, isSkipping, updateWizardData
    } = props;
    const [scriptML, updateScriptML] = useState([]);
    const [showErrors, setShowErrors] = useState(false);

    const {nextStepVisited} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        addWarningAlert,
        clearWarningAlerts
    } = MLNotificationBlockUtil();

    const { isComponentValid } = useValidation('hoDisclosureToQuote');

    // init
    const hoModel = submissionVM.lobData.homeowners.value;
    const [insurViewWarningMsg, setInsurViewWarningMsg] = useState(false);
    const disclosures = _.get(hoModel, 'coverables.disclosures_ML.losses') || [];
    const LOB_TYPE_HOP = 'HOP';
    const HOME_DISCLOSURE_STEP = 'hoDisclosureToQuote';


    const nextStepText_Ext = () => {
        return (
            <FormattedMessage
                {...messages.continueText}
                values={{
                    reviewYourQuote: (
                        <strong>{translator(messages.reviewYourQuote)}</strong>
                    )
                }}
            />
        );
    };

    const updateProductModel = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'HO Disclosure Page'});
            });

            LoadSaveService.getScript(HOME_DISCLOSURE_STEP, { quoteID: submissionVM.quoteID.value }, authHeader)
                .then((lines) => {
                    updateScriptML(lines);
            });

        }
    }, []);

    // wizard page

    const onNext = async() => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Quote Step Submitted', false, submissionVM, user, {step: 'HO Disclosure Page',  action: 'HO Disclosure Page Submitted'});
            });
        }
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        if (!isComponentValid) {
            return false;
        }

        if (!_.isEmpty(disclosures)) {
            hoModel.coverables.disclosures_ML.losses = disclosures.filter((loss) => {
                return _.isUndefined(loss.removeReason) || loss.removeReason === null;
            });
        }

        showProgressDialog(platformMessages.saveAndQuoteSubmission);
        clearWarningAlerts();
        try {
            if (nextStepVisited()) {
                goNext();
            } else {
                _.unset(submissionVM.value, 'bindData.paymentDetails');
                const res = await LoadSaveService.saveAndQuoteSubmission(
                    submissionVM.value,
                    authHeader
                );
                submissionVM.value = res;
                const warningMsgs = res.lobData.homeowners.warnings;
                let ignoreInsurviewWarning = true;
                if (warningMsgs != null && warningMsgs.length > 0) {
                    warningMsgs.forEach((value) => {
                        if (value !== " " && value !== null) {
                            addWarningAlert(value, 'InsurviewWarning');
                        }
                    });
                    window.scrollTo(0, 0);
                    if (insurViewWarningMsg) {
                        ignoreInsurviewWarning = true;
                    } else {
                        ignoreInsurviewWarning = false;
                    }
                    setInsurViewWarningMsg(true);
                }
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
                if (ignoreInsurviewWarning === true) {
                    if (!nextStepVisited()) {
                        return submissionVM;
                    }
                    goNext();
                }
            }
        } catch(error) {
            // US963262: Handle CDCE Exceptions error
            hideProgressDialog();
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        } finally {
            hideProgressDialog(platformMessages.saveAndQuoteSubmission);
        }
        return false;
    };

    const resolvers = {
        resolveComponentMap: {
            mldisclosurecomponent: MLDisclosureComponent,
            mlscriptcomponent: MLScriptComponent
        },
        resolveCallbackMap: {
            onNext
        }
    };

    const overrideProps = {
        mlDisclosureComponent: {
            disclosures,
            owners: submissionVM.value.persons,
            type: MLDisclosureUtil.getLossType(),
            isAgent: true,
            lineOfBusiness: LOB_TYPE_HOP,
            updateProductModel
        },
        mlScriptComponent: {
            visible: isGPA && !_.isEmpty(scriptML),
            mlScript: scriptML
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        stickyfootercomponent: {
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext
        }
    };

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'hoDisclosureToQuote') {
            return false;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.value.isBundle_ML
            && submissionVM.value.baseData.status_ML !== 'Draft') {
            return true;
        }

        return true;
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyfootercomponent'
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                showErrors={showErrors}
            />
        </WizardPage>
    );
}

HODisclosureToQuote.propTypes = wizardProps;

export default HODisclosureToQuote;